import { useEffect, useRef, useState } from "react";

import { useKioskSaveDayNoteMutation } from "../api/klassenbuchKioskApi";
import type { ClassWeekCacheKey } from "../types/kioskApiTypes";

export function DayNoteCell({
  classId,
  date,
  initialNote,
  classWeekKey,
  userId,
}: {
  classId: string;
  date: string;
  initialNote: string | null;
  classWeekKey: ClassWeekCacheKey;
  /** Teacher user_id from the chip-login session — required so the
   *  day-note upsert stamps the right `created_by` instead of falling
   *  back to auth.uid() = kiosk_id (which isn't in user_profiles and
   *  fails the FK constraint). See
   *  20260520_kiosk_day_note_paired_callable.sql. */
  userId: string;
}) {
  const [text, setText] = useState(initialNote ?? "");
  const [flash, setFlash] = useState(false);
  const [saveDayNote] = useKioskSaveDayNoteMutation();
  const focusedRef = useRef(false);

  useEffect(() => {
    if (focusedRef.current) return;
    setText(initialNote ?? "");
  }, [initialNote]);

  const handleBlur = async () => {
    focusedRef.current = false;
    if (text.trim() === (initialNote ?? "").trim()) return;
    await saveDayNote({ classId, userId, date, text: text.trim(), _classWeekKey: classWeekKey });
    setFlash(true);
    setTimeout(() => setFlash(false), 1200);
  };

  return (
    <div className="text-left font-sans">
      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        onFocus={() => { focusedRef.current = true; }}
        onBlur={handleBlur}
        placeholder="Tagesbemerkung…"
        rows={2}
        className="w-full bg-white/80 border border-stone-300 text-[11px] font-normal text-stone-700 placeholder:text-stone-400 resize-none focus:outline-none focus:bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-400 rounded px-1.5 py-1 leading-snug"
      />
      {flash ? (
        <span className="block text-[9px] text-emerald-700 leading-none mt-0.5">✓</span>
      ) : null}
    </div>
  );
}
